import "./ImageContainer.css";

export default function ImageContainer({
  src,
  alt,
  className = "",
  useOverlay = false,
  overlayColor = "var(--color-client-company)",
  overlayBlur = "0px",
  overlayOpacity = "0.45",
  backgroundColor = "transparent",
}) {
  return (
    <div
      className={["ImageContainer", className].filter(Boolean).join(" ")}
      style={
        useOverlay
          ? { background: overlayColor }
          : { backgroundColor: backgroundColor }
      }
    >
      <img
        className="ImageContainer-img"
        src={src}
        alt={alt}
        title={alt}
        style={
          useOverlay
            ? {
                filter: `grayscale(100%) blur(${overlayBlur})`,
                opacity: `${overlayOpacity}`,
              }
            : null
        }
      />
    </div>
  );
}
